import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'
import * as types from 'actions/messages/types';

const MessageHelp = ({ getNewConversation, list, chatWithExpert }) => {
  const history = useHistory()
  const handleClick = async () => {
    const data = await chatWithExpert()
    if (!list.find(con => con.id === Number(data.id))) await getNewConversation(data.id)
    history.push(`/merchant/messages/${data.id}/conversation`)
  }
  return (
    <div className="sticky bottom-0 py-2">
      <div className="mx-6 bg-primary-seafoam rounded-lg cursor-pointer" onClick={() => handleClick()}>
        <div className="flex justify-start py-3">
          <div className="h-10 mx-2 min-w_10 max-w_10 rounded-full bg-white">
            <img alt="message" src={require('assets/images/flyspaces-logo-only.png')} className="object-contain rounded-full w-full h-full" />
          </div>
          <div className="h-10 text-white table">
            <p className="text-sm table-cell align-middle">Need help? <span className="font-semibold">Message a Space Expert!</span></p>
          </div>
        </div>
      </div>
    </div>
  );
}

MessageHelp.propTypes = {
  getNewConversation: PropTypes.func,
  list: PropTypes.array,
  chatWithExpert: PropTypes.func
}

const mapStateToProps = ({ messages }) => ({
  list: messages.conversation.list,
});

const mapDispatchToProps = dispatch => ({
  chatWithExpert: (payload) => new Promise((resolve, reject) => {
    dispatch({ type: types.CHAT_WITH_EXPERT, payload, resolve, reject });
  }),
  getNewConversation: (payload) => new Promise((resolve, reject) => {
    dispatch({ type: types.GET_NEW_CONVERSATION, payload, resolve, reject });
  }),
})

export default connect(mapStateToProps, mapDispatchToProps)(MessageHelp);
